import * as React from 'react';
import ReviewForm from "../../components/Reviews/ReviewForm/ReviewForm";
var Review = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041F\u0440\u043E\u043C\u044F\u043D\u0430 \u043D\u0430 \u043E\u0442\u0437\u0438\u0432"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: 'offset-md-4' },
                    React.createElement(ReviewForm, null))))));
};
export default Review;



//////////////////
// WEBPACK FOOTER
// ./src/views/Reviews/Review.tsx
// module id = 434
// module chunks = 0